import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

/**
 * Inject MatSnackBar anywhere in the application
 *
 * Usage: `this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        title: 'Title is optional',
        message:
          'Your desired message',
        icon: 'use it if you want to add custom icon',
        type: 'success',
      },
      panelClass: 'success',
      duration: 5000,
      horizontalPosition: 'start',
    });`
 */

interface CustomSnackbar {
  title?: string;
  message: string;
  type: 'success' | 'warning' | 'info' | 'danger';
  icon?: string;
}

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss',
})
export class CustomSnackbarComponent {
  data = inject<CustomSnackbar>(MAT_SNACK_BAR_DATA);
}
